export const transformCentsToDollars = (value: number | string) => {
  const valueString = value.toString().replace(/[^\d.-]/g, '')
  return valueString ? parseFloat(valueString) / 100 : 0
}
